// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/hr/tipologie-dispositivo?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,nome,attiva}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/hr/ubicazioni-dispositivo?societaId',
    requestBody: null,
    response: '{success:true,data:[{id,nome,attiva,descrizione,sedeId,sede}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/hr/dispositivi-aziendali?societaId&stato&tipologiaId&proprieta&ubicazioneId&q',
    requestBody: null,
    response: '{success:true,data:[{id,societaId,codiceMatricola,tipologia,marca,modello,seriale,partNumber,proprieta,stato,ubicazioneCorrente,assegnazioneAttiva}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/hr/dispositivi-aziendali',
    requestBody: '{societaId,codiceMatricola,tipologiaId,proprieta,marca,modello,seriale,partNumber,ubicazioneId}',
    response: '{success:true,data:{id,codiceMatricola}}'
  },
  {
    method: 'PATCH',
    endpoint: '/api/hr/dispositivi-aziendali/:id/dismetti',
    requestBody: null,
    response: '{success:true,data:{id,stato}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
